import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500">找到你喜欢的漫画类型，开启精彩阅读之旅</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${cat.icon} text-xl text-foreground-600 group-hover:text-primary-600 transition-colors duration-300`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-700 transition-colors duration-300 whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}